import { Users } from 'lucide-react';
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { NotificationSound } from "../../CommonComponents/CommonNotification";
import { ApiCall, deleteData, sanitizeInput } from "../../CommonComponents/CustomHooks";
import { CommonApiData, initializeFilterData } from "../../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../../CommonComponents/ExportData";
import { AutoCompleteBoxNew, FormButton, InputBox, Switch } from "../../CommonComponents/InputBox";
import { Table } from "../../CommonComponents/Table";
import { setSubLoading } from "../../Redux/Services/AuthSlice";

const UserGroupMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch([])
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [formData, setFormData] = useState({
        userGroupID: '',
        groupName: '',
        groupHead: '',
        active: true
    });
    const loginCompanyCode= CommonApiData().companyCode 

    const getGroupMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/User/ShowUserGroupMaster`, data)
        if (res.Status === 'SUCCESS') {
            setTableData(res)
        }
        if (res.Status === 'ERROR') {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = () => {
        setFormData({
            groupName: '',
            userGroupID: '',
            groupHead: '',
            active: true,
        })
        filterData.SearchText = ''
        inputrefs.current['txtGroupName'].focus()
        getGroupMasterData()
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/User/InsertUpdateUserGroupMaster`, { ...formData })
        await dispatch(setSubLoading(false))
        inputrefs.current['txtGroupName'].focus()
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/User/EditUserGroupMaster`, { UserGroupID: id, loginCompanyCode})
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            await inputrefs.current[editData.focus].focus();
            let record = editData
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/User/DeleteUserGroupMaster`, { UserGroupID: id, loginCompanyCode }, getGroupMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleChange1 = (event, value) => {
        getGroupMasterData(value);
    };
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };
    useEffect(() => {
        inputrefs.current['txtGroupName'].focus()
        document.title = 'Group Master'
        getGroupMasterData()
    }, [sortConfig]);

    return (
        <>
                <div className='bg-white rounded-lg shadow-sm p-6 mb-6'>
                    <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center gap-2">
                            <Users className="w-6 h-6 text-teal-600" />
                            <h2 className="text-xl font-semibold text-gray-800">User Group Master</h2>
                        </div>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <InputBox
                                label='Group Name'
                                required={true}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtGroupHead'].focus()
                                    }
                                }}
                                inputrefs={inputrefs}
                                id="txtGroupName"
                                placeholder='Enter Group Name'
                                type="text"
                                maxLength='30'
                                value={formData.groupName}
                                onChange={(e) => setFormData({ ...formData, groupName: sanitizeInput(e.target.value) })}
                            />
                           
                            <AutoCompleteBoxNew
                                //     divclassname='col-md-4 mb-1'
                                id="txtGroupHead"
                                placeholder="Group Head"
                                label='Group Head'
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current["txtActive"].focus(); };
                                }}
                                required={true}
                                autocompleteType='GetUser  '
                                value={formData.groupHead || ''}
                                onChange={async (event, newInputValue) => {
                                    newInputValue = newInputValue || ''
                                    if (event.type !== 'keydown') {
                                        setFormData({ ...formData, groupHead: newInputValue })
                                    }
                                }}
                                //maxLength='50'
                            />
                            <Switch
                                label='Active'
                                checked={formData.active}
                                id='txtActive'
                                divclassname='col-md-3 mt-4  cntrl-width'
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus()
                                    };
                                }}
                                onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                            />
                        </div>


                    </div>
                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                handleDownloadExcel(`/api/User/ShowUserGroupMaster`, filterData, 'User Group Master')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
                <Table
                    handleEdit={handleEditData}
                    handleDelete={handleDelete}
                    loading={isLoading}
                    PageName={'UserGroupMaster'}
                    handleFilter={() => {
                        getGroupMasterData(1)
                        setFilterData({
                            ...filterData,
                        })
                    }}
                    filterData={filterData}
                    tableData={tableData}
                    setFilterData={setFilterData}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                    handleSorting={handleSorting}
                    sortConfig={sortConfig}
                />
        </>
    )
}
export default UserGroupMaster;